import React from 'react';
import { Plus } from 'lucide-react';
import { Layout } from '../components/Layout';
import { DomainList } from '../components/DomainList';
import { AddDomainForm } from '../components/AddDomainForm';

export function DashboardPage() {
  const [showAddDomain, setShowAddDomain] = React.useState(false);
  const [refreshKey, setRefreshKey] = React.useState(0);

  function handleDomainAdded() {
    setShowAddDomain(false);
    setRefreshKey(prev => prev + 1); // Trigger refresh
  }

  return (
    <Layout>
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-slate-900">Domains</h1>
            <p className="text-slate-500 mt-1">Manage your custom email domains</p>
          </div>

          {!showAddDomain && (
            <button
              onClick={() => setShowAddDomain(true)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg font-semibold shadow-sm transition-all hover:shadow-md flex items-center gap-2"
            >
              <Plus size={20} /> Add Domain
            </button>
          )}
        </div>

        {/* Add Domain Section */}
        {showAddDomain && (
          <div className="mb-8">
            <AddDomainForm
              onSuccess={handleDomainAdded}
              onCancel={() => setShowAddDomain(false)}
            />
          </div>
        )}

        {/* Domains List */}
        <DomainList key={refreshKey} />
      </div>
    </Layout>
  );
}
